const Qna = () => {
    window.location.replace('https://heuguchon.zendesk.com/hc/ko/requests/new');
    return null;
};

export default Qna;